import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { useAuth } from "../auth";
import { toast } from "sonner";

export default function ForgotPage() {
  const { API } = useAuth();
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/auth/forgot`, { email });
      setDone(true);
    } catch (err) {
      toast.error("Please try again shortly");
    }
  };
  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-16" data-testid="forgot-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <p className="tcm-eyebrow mb-4">The Curated Mile</p>
          <h1 className="font-display text-4xl tracking-tight">Reset password</h1>
          <hr className="tcm-gold-rule w-16 mx-auto mt-4" />
        </div>
        <div className="tcm-double-frame">
          <div className="tcm-inner p-8">
            {done ? (
              <p className="text-center">If an account matches, a reset link has been sent.</p>
            ) : (
              <form onSubmit={submit} className="space-y-6">
                <div>
                  <label className="tcm-eyebrow block mb-2">Email</label>
                  <input data-testid="forgot-email-input" type="email" required className="tcm-input"
                         value={email} onChange={(e) => setEmail(e.target.value)} />
                </div>
                <button data-testid="forgot-submit-button" className="tcm-btn-primary w-full">Send reset link</button>
              </form>
            )}
            <div className="mt-6 text-center">
              <Link to="/" className="tcm-eyebrow underline decoration-[#C9A961] underline-offset-4">Back to sign in</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
